import classNames from 'classnames';
import { FunctionalComponent, h } from 'preact';

type Props = {
    center?: boolean;
    className?: string;
    large?: boolean;
};

export const ModalContent: FunctionalComponent<Props> = ({
    children,
    large,
    center,
    className,
}) => (
    <div
        className={classNames(
            'c-modal__content',
            {
                't-display-2': !large,
                't-display-3': large,
                'u-text-center': center,
            },
            className,
        )}
    >
        {children}
    </div>
);
